import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    campaign: [],
    segment_list: [],
    selected_segments: null
};

export const metaTravelAdsSlice = createSlice({
  name: "metaTravelAdsSlice",
  initialState: initialState,
  reducers: {
    updateCampaign: (state, action) => {
      state.campaign = action.payload;
    },
    updateSelectedSegments: (state,action) => {
      state.selected_segments = action.payload;
    },
    updateSegmentList: (state, action) => {
      state.segment_list = action.payload;
    },
    resetMetaTravelAds: () => initialState
  },
});

export const {
  updateSegmentList,
  updateSelectedSegments,
  updateBiddingLevel,
  resetMetaTravelAds
} = metaTravelAdsSlice.actions;
export default metaTravelAdsSlice.reducer;
